// ClubStars — the prestige strip: five milestone stars, earned forever.
// Each filled star is a permanent +2% income (modifier engine).

import { useGameStore } from '@/store/gameStore'
import { STAR_MILESTONES } from '@/config/prestigeConfig'
import { SectionDeck } from '../CourtVision'
import { Star } from 'lucide-react'

export function ClubStars() {
  const clubStars = useGameStore(s => s.clubStars)

  return (
    <SectionDeck
      title="Estrellas del Club"
      icon={Star}
      meta={`${clubStars.length}/${STAR_MILESTONES.length} · +${clubStars.length * 2}% ingresos`}
    >
      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        {STAR_MILESTONES.map(milestone => {
          const earned = clubStars.includes(milestone.id)
          return (
            <div
              key={milestone.id}
              title={`${milestone.name}: ${milestone.description}`}
              style={{
                flex: '1 1 150px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 0.6rem',
                borderRadius: 'var(--radius-sm)',
                border: earned
                  ? '1px solid color-mix(in srgb, var(--gold) 55%, transparent)'
                  : '1px solid var(--glass-border)',
                background: earned ? 'var(--gold-fill)' : 'transparent',
                opacity: earned ? 1 : 0.55,
              }}
            >
              <Star
                size={18}
                style={{ color: earned ? 'var(--gold)' : 'var(--text-muted)', flexShrink: 0 }}
                fill={earned ? 'currentColor' : 'none'}
              />
              <div>
                <div style={{ fontSize: '0.72rem', fontWeight: 700, color: earned ? 'var(--gold)' : 'var(--text-secondary)' }}>
                  {milestone.emoji} {milestone.name}
                </div>
                <div className="meta-text" style={{ fontSize: '0.62rem' }}>{milestone.description}</div>
              </div>
            </div>
          )
        })}
      </div>
    </SectionDeck>
  )
}
